module.exports = __webpack_public_path__ + "img/vr-app-banner.d6e220fb.webp";